import React from "react";
import styles from "../../styles/Product.module.css";

interface SpecSheetCar {
  year?: number | null;
  make?: string | null;
  model?: string | null;
  trim?: string | null;
  mileage?: number | null;
  bodyStyle?: string | null;
  fuelType?: string | null;
  engine?: string | null;
  transmission?: string | null;
  driveType?: string | null;
  exteriorColor?: string | null;
  interiorColor?: string | null;
  vin?: string | null;
  titleStatus?: string | null;
  hasVerifiedTitle?: boolean | null;
}

interface SpecSheetProps {
  car: SpecSheetCar;
  transmissionDisplay?: string | null;
}

const SpecSheet: React.FC<SpecSheetProps> = ({ car, transmissionDisplay }) => {
  const rows: Array<{ label: string; value: React.ReactNode }> = [
    { label: "Year", value: car.year },
    { label: "Make", value: car.make },
    { label: "Model", value: car.model },
    { label: "Trim", value: car.trim },
    {
      label: "Mileage",
      value: car.mileage != null ? `${car.mileage.toLocaleString()} mi` : null,
    },
    { label: "Body style", value: car.bodyStyle },
    { label: "Engine", value: car.engine },
    { label: "Transmission", value: transmissionDisplay ?? car.transmission },
    { label: "Drivetrain", value: car.driveType },
    { label: "Fuel type", value: car.fuelType },
    { label: "Exterior color", value: car.exteriorColor },
    { label: "Interior color", value: car.interiorColor },
    { label: "VIN", value: car.vin },
    { label: "Title status", value: car.titleStatus },
    {
      label: "Title on file",
      value: car.hasVerifiedTitle ? "Yes" : null,
    },
  ].filter((r) => r.value !== null && r.value !== undefined && r.value !== "") as Array<{
    label: string;
    value: React.ReactNode;
  }>;

  if (rows.length === 0) {
    return <p className={styles.noSpecs}>No vehicle details provided.</p>;
  }

  return (
    <dl className={styles.specSheet}>
      {rows.map((row) => (
        <div key={row.label} className={styles.specRow}>
          <dd className={styles.specRowValue}>{row.value}</dd>
          <dt className={styles.specRowLabel}>{row.label}</dt>
        </div>
      ))}
    </dl>
  );
};

export default SpecSheet;
